module.exports = {
  main_settings: 'Main settings',
  preset: 'Preset',
  metrics: 'Metrics',
  project_records: 'Project records',
  reports: 'Reports',
  triggers: 'Triggers',
};
